export const STORY_SERVICE_API = process.env.REACT_APP_STORY_SERVICE_API;

export const PAGE_SIZE = 24;

// Tab order === PLATFORMS order; `key` is also the endpoint path segment.
export const PLATFORMS = [
  { key: 'instagram', label: 'Instagram', icon: 'instagram' },
  { key: 'tiktok', label: 'TikTok', icon: 'video' },
];



/** WEBPACK FOOTER **
 ** ./src/components/all-stories-modal/constants.js
 **/